import React, { useEffect, useState } from "react";
import axios from "axios";
import BASE_URL from "../config";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import SidebarRFQ from "../POpage/SidebarRFQ";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Select from "react-select";

const ListRFQ = () => {
  const navigate = useNavigate();
  const [rfqData, setRfqData] = useState([]);
  const [file1, setFile1] = useState(null);
  const [selectedRFQ, setSelectedRFQ] = useState(null);
  const [clients, setClients] = useState([]);
  const [suppiler, setSupplier] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 50;
  const [searchTerm, setSearchTerm] = useState("");
  const user = JSON.parse(localStorage.getItem("userdata"));
  const [showUpcoming, setShowUpcoming] = useState(false);
  const [filterStatus, setFilterStatus] = useState("");
  const [filterBidStatus, setFilterBidStatus] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [dateType, setDateType] = useState("");
  // rfq_date | closing_date | quote_submit_date

  const [originalRfqData, setOriginalRfqData] = useState([]);

  const statusStyles = {
    "RFQ Sent": "bg-info text-white",
    "Supplier Quote received": "bg-primary text-white",
    "Quote submitted to Client": "bg-success text-white",
    "Quote not Received From Supplier": "bg-danger text-white",
    "Under clarification": "bg-warning text-dark",
  };

  const bidStatusStyles = {
    Won: "bg-success text-white",
    Lost: "bg-danger text-white",
    Onhold: "bg-secondary text-white",
    "In-Progress": "bg-warning text-white",
  };

  useEffect(() => {
    fetchRFQData();
    fetchClients();
    fetchSupplier();
  }, []);

  const fetchRFQData = () => {
    axios
      .get(`${BASE_URL}/api/get-rfq-data`)
      .then((res) => {
        const reversed = res.data.reverse();
        setRfqData(reversed);
        setOriginalRfqData(reversed);
      })
      .catch((err) => console.error("Error fetching RFQ data:", err));
  };

  const fetchClients = () => {
    axios
      .get(`${BASE_URL}/api/client-get`)
      .then((res) => setClients(res.data))
      .catch((err) => console.error("Error fetching clients:", err));
  };

  const fetchSupplier = () => {
    axios
      .get(`${BASE_URL}/api/supplier-get`)
      .then((res) => setSupplier(res.data))
      .catch((err) => console.error("Error fetching suppliers:", err));
  };

  const openStatusModal = (rfq) => {
    setFile1(rfq.rfq_attachment); // Clear file unless new one selected
    setSelectedRFQ({ ...rfq });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "client_name" && value === "add_new") {
      // navigate("/clientadd");
      window.location.href = "/clientadd";

      return;
    }

    if (name === "manufacturer_supplier" && value === "add_new") {
      // navigate("/supplier");
      window.location.href = "/supplier";

      return;
    }

    const updated = { ...selectedRFQ, [name]: value };

    if (name === "status" && value === "Quote submitted to Client") {
      updated.quote_submit_client_date = new Date().toISOString().slice(0, 10);
    }

    setSelectedRFQ(updated);
  };

  const submitStatusUpdate = async () => {
    const sendData = new FormData();

    // Append everything except rfq_attachment
    Object.entries(selectedRFQ).forEach(([key, value]) => {
      if (key !== "rfq_attachment") {
        sendData.append(key, value);
      }
    });
    sendData.append("old_file", selectedRFQ.rfq_attachment);

    // If a new file is selected
    if (file1 instanceof File) {
      sendData.append("rfq_attachment", file1);
    }

    try {
      await axios.post(
        `${BASE_URL}/api/update-rfq/${selectedRFQ.id}?_method=PUT`,
        sendData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      fetchRFQData();
      handleSubmitCreateRFQ();
      Swal.fire("Success", "RFQ status updated successfully!", "success");

      const modal = window.bootstrap.Modal.getInstance(
        document.getElementById("statusModal")
      );
      modal.hide();
    } catch (error) {
      console.error("Status update failed:", error);
      // Swal.fire("Error", "Failed to update status.", "error");
    }
  };

  const handleSubmitCreateRFQ = async () => {
    try {
      const response = await axios.post(
        "https://bimanager.nexteck.uk/api/messages",
        {
          user_id: user.id,
          type: "RFQ",
          message: "RFQ Edit",
          status: "0",
        }
      );
      console.log(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const [selectedClients, setSelectedClients] = useState([]);
  const [checkAllClients, setCheckAllClients] = useState(true);

  const [selectedAssignedStaff, setSelectedAssignedStaff] = useState([]);
  const [checkAllAssignedStaff, setCheckAllAssignedStaff] = useState(true);

  const [suppliers, setSuppliers] = useState([]);

  // Initialize unique client and assigned staff list
  useEffect(() => {
    const uniqueClients = [
      ...new Set(rfqData.map((rfq) => rfq.client_name).filter(Boolean)),
    ].map((name) => ({ client_name: name }));

    const uniqueStaff = [
      ...new Set(rfqData.map((rfq) => rfq.assigned_staff).filter(Boolean)),
    ].map((name) => ({ name }));

    setClients(uniqueClients);
    setSuppliers(uniqueStaff);
  }, [rfqData]);

  // Filtering logic

 const filteredData = rfqData
  .filter((rfq) => {
    const matchSearch = Object.values(rfq).some((v) =>
      v?.toString().toLowerCase().includes(searchTerm.toLowerCase())
    );

    const matchClient =
      selectedClients.length === 0 ||
      selectedClients.includes(rfq.client_name);

    const matchStaff =
      selectedAssignedStaff.length === 0 ||
      selectedAssignedStaff.includes(rfq.assigned_staff);

    const matchStatus = !filterStatus || rfq.status === filterStatus;
    const matchBidStatus =
      !filterBidStatus || rfq.bid_status === filterBidStatus;

    // ✅ FIXED DATE FILTER
    let matchDate = true;

    if (startDate || endDate) {
      const field = dateType || "rfq_date"; // 👉 default rfq_date

      const value = rfq[field];

      if (!value) return false;

      const rfqDate = new Date(value);
      if (isNaN(rfqDate)) return false;

      if (startDate && rfqDate < new Date(startDate)) {
        matchDate = false;
      }

      if (endDate && rfqDate > new Date(endDate)) {
        matchDate = false;
      }
    }

    return (
      matchSearch &&
      matchClient &&
      matchStaff &&
      matchStatus &&
      matchBidStatus &&
      matchDate
    );
  })
    // ✅ SORT BY SELECTED DATE (ASC)
    .sort((a, b) => {
      if (!dateType) return 0;
      return new Date(a[dateType]) - new Date(b[dateType]);
    });

  // Client checkbox handlers
  const handleClientCheckboxChange = (name) => {
    if (selectedClients.includes(name)) {
      const updated = selectedClients.filter((c) => c !== name);
      setSelectedClients(updated);
      setCheckAllClients(false);
    } else {
      const updated = [...selectedClients, name];
      setSelectedClients(updated);
      setCheckAllClients(updated.length === clients.length);
    }
  };

  const handleClientCheckAll = () => {
    if (checkAllClients) {
      setSelectedClients([]);
      setCheckAllClients(false);
    } else {
      const all = clients.map((c) => c.client_name);
      setSelectedClients(all);
      setCheckAllClients(true);
    }
  };

  // Assigned staff checkbox handlers
  const handleAssignedStaffCheckboxChange = (name) => {
    if (selectedAssignedStaff.includes(name)) {
      const updated = selectedAssignedStaff.filter((s) => s !== name);
      setSelectedAssignedStaff(updated);
      setCheckAllAssignedStaff(false);
    } else {
      const updated = [...selectedAssignedStaff, name];
      setSelectedAssignedStaff(updated);
      setCheckAllAssignedStaff(updated.length === suppliers.length);
    }
  };

  const handleAssignedStaffCheckAll = () => {
    if (checkAllAssignedStaff) {
      setSelectedAssignedStaff([]);
      setCheckAllAssignedStaff(false);
    } else {
      const all = suppliers.map((s) => s.name);
      setSelectedAssignedStaff(all);
      setCheckAllAssignedStaff(true);
    }
  };

  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const getPaginationGroup = () => {
    let start = Math.floor((currentPage - 1) / 5) * 5;
    return new Array(Math.min(5, totalPages - start))
      .fill()
      .map((_, i) => start + i + 1);
  };
  const limitWords = (text, charLimit = 50) => {
    if (!text) return "-";
    text = text.toString();
    return text.length > charLimit ? text.slice(0, charLimit) + "..." : text;
  };
  const TruncatedText = ({ text, limit = 40 }) => {
    if (!text) return <span>-</span>;

    const truncated = text.length > limit ? text.slice(0, limit) + "..." : text;

    return (
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id={`tooltip-${Math.random()}`}>{text}</Tooltip>}
      >
        <span style={{ cursor: "pointer" }}>{truncated}</span>
      </OverlayTrigger>
    );
  };

  const TruncatedTextSupplier = ({ text, limit = 15 }) => {
    if (!text) return <span>-</span>;

    const truncated = text.length > limit ? text.slice(0, limit) + "..." : text;

    return (
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id={`tooltip-${Math.random()}`}>{text}</Tooltip>}
      >
        <span style={{ cursor: "pointer" }}>{truncated}</span>
      </OverlayTrigger>
    );
  };

  const [selectedRFQs, setSelectedRFQs] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  // ✅ Select / Unselect all rows
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedRFQs([]);
    } else {
      setSelectedRFQs(currentData.map((rfq) => rfq.id));
    }
    setSelectAll(!selectAll);
  };

  // ✅ Select / Unselect individual RFQ
  const handleSelectRFQ = (id) => {
    setSelectedRFQs((prev) =>
      prev.includes(id) ? prev.filter((rfqId) => rfqId !== id) : [...prev, id]
    );
  };

  // ✅ Delete selected RFQs
  const deleteSelectedRFQs = async () => {
    if (selectedRFQs.length === 0) {
      Swal.fire("Please select at least one RFQ to delete");
      return;
    }

    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: `You are about to delete ${selectedRFQs.length} RFQ(s).`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete",
    });

    if (!confirm.isConfirmed) return;

    try {
      await Promise.all(
        selectedRFQs.map((id) => axios.delete(`${BASE_URL}/api/rfq/${id}`))
      );

      Swal.fire("Deleted!", "Selected RFQs have been deleted.", "success");

      // Remove deleted RFQs from table
      setRfqData((prev) =>
        prev.filter((rfq) => !selectedRFQs.includes(rfq.id))
      );
      setSelectedRFQs([]);
      setSelectAll(false);
    } catch (error) {
      console.error(error);
      Swal.fire(
        error.response?.data?.message || "Failed to delete selected RFQs"
      );
    }
  };

  const DeleteRFQ = async (rfqId) => {
    try {
      const res = await axios.delete(`${BASE_URL}/api/rfq/${rfqId}`);

      if (res.status === 200) {
        Swal.fire("RFQ deleted successfully");

        // Optionally refresh your list
        setRfqData((prev) => prev.filter((item) => item.id !== rfqId));
      }
    } catch (error) {
      console.error(error);
      Swal.fire(
        error.response?.data?.message || "Failed to delete RFQ. Try again."
      );
    }
  };

  return (
    <div className="row">
      <div className="custom-2-5">
        <SidebarRFQ />
      </div>
      <div className="custom-9-5 dashboardsclooer p-3">
        <h3>RFQ List</h3>
        <div className="row">
          <div className="col-lg-4">
            {/* <label> Search</label> */}
            <input
              className="form-control w-100"
              placeholder="Search by any field..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
            />
          </div>

          {/* Client Filter Dropdown */}
          <div className="col-lg-3">
            <div className="dropdown">
              <button
                className="btn btn-outline-primary dropdown-toggle"
                type="button"
                id="clientDropdown"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Filter by Client Type
              </button>
              <div
                className="dropdown-menu custom-dropdown"
                aria-labelledby="clientDropdown"
              >
                <label className="dropdown-item">
                  <input
                    type="checkbox"
                    checked={checkAllClients}
                    onChange={handleClientCheckAll}
                  />{" "}
                  <strong>All</strong>
                </label>
                <div className="dropdown-divider"></div>
                {clients.map((client, index) => (
                  <label key={index} className="dropdown-item">
                    <input
                      type="checkbox"
                      checked={selectedClients.includes(client.client_name)}
                      onChange={() =>
                        handleClientCheckboxChange(client.client_name)
                      }
                    />{" "}
                    {client.client_name}
                  </label>
                ))}
              </div>
            </div>
          </div>

          {/* Assigned Staff Filter Dropdown */}
          <div className="col-lg-3">
            <div className="dropdown">
              <button
                className="btn btn-outline-success dropdown-toggle"
                type="button"
                id="staffDropdown"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Filter by Assigned Staff
              </button>
              <div
                className="dropdown-menu custom-dropdown"
                aria-labelledby="staffDropdown"
              >
                <label className="dropdown-item">
                  <input
                    type="checkbox"
                    checked={checkAllAssignedStaff}
                    onChange={handleAssignedStaffCheckAll}
                  />{" "}
                  <strong>All</strong>
                </label>
                <div className="dropdown-divider"></div>
                {suppliers.map((supplier, index) => (
                  <label key={index} className="dropdown-item">
                    <input
                      type="checkbox"
                      checked={selectedAssignedStaff.includes(supplier.name)}
                      onChange={() =>
                        handleAssignedStaffCheckboxChange(supplier.name)
                      }
                    />{" "}
                    {supplier.name}
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="row mt-3">
          {/* Status Filter */}
          <div className="col-lg-3">
            <select
              className="form-control"
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
            >
              <option value="">Filter by Status</option>
              <option>RFQ Sent</option>
              <option>Supplier Quote received</option>
              <option>Quote submitted to Client</option>
              <option>Quote not Received From Supplier</option>
              <option>Under clarification</option>
            </select>
          </div>

          {/* Bid Status Filter */}
          <div className="col-lg-2">
            <select
              className="form-control"
              value={filterBidStatus}
              onChange={(e) => setFilterBidStatus(e.target.value)}
            >
              <option value="">Bid Status</option>
              <option>Won</option>
              <option>Lost</option>
              <option>Onhold</option>
              <option>In-Progress</option>
            </select>
          </div>

          {/* Date Type */}
          <div className="col-lg-2">
            <select
              className="form-control"
              value={dateType}
              onChange={(e) => setDateType(e.target.value)}
            >
              <option value="">Date Type</option>
              <option value="rfq_date">RFQ Received Date</option>
              <option value="closing_date">RFQ Closing Date</option>
              <option value="quote_submit_date">Quote Submit Date</option>
            </select>
          </div>

          {/* Start Date */}
          <div className="col-lg-2">
            <input
              type="date"
              className="form-control"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>

          {/* End Date */}
          <div className="col-lg-2">
            <input
              type="date"
              className="form-control"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>

          {/* Reset */}
          <div className="col-lg-1">
            <button
              className="btn btn-secondary w-100"
              onClick={() => {
                setFilterStatus("");
                setFilterBidStatus("");
                setStartDate("");
                setEndDate("");
                setDateType("");
              }}
            >
              Reset
            </button>
          </div>
        </div>

        <div className="mt-3">
          <div className="mb-1">
            {user.deletestatus === "1" && (
              <button
                className="btn btn-danger mb-1"
                onClick={deleteSelectedRFQs}
              >
                Delete Selected
              </button>
            )}
          </div>

          <div
            className=" table-container"
            style={{
              height: "calc(100vh - 257px)",
              overflowY: "auto",
              overflowX: "auto",
              position: "relative",
            }}
          >
            <table className="table table-bordered custom-table">
              <thead className="thead-sticky">
                <tr>
                  {user.deletestatus === "1" && (
                    <th className="sticky-col sticky-0 col-checkbox">
                      <input
                        type="checkbox"
                        checked={selectAll}
                        onChange={handleSelectAll}
                      />
                    </th>
                  )}
                  <th className="sticky-col sticky-1 col-action">Action</th>
                  <th className="sticky-col sticky-2 col-rfq">RFQ Number</th>
                  <th className="sticky-col sticky-3 col-date">
                    RFQ Received Date
                  </th>
                  <th>Client</th>
                  <th>Status</th>
                  <th>RFQ Closing Date</th>
                  <th>Quote Submit Date</th>
                  <th>Latest Update</th>
                  <th>Item Description</th>
                  <th>Client Contact</th>
                  <th>Client Email</th>
                  <th>Manufacturer/Supplier</th>
                  <th>Assigned Staff</th>
                  <th>Bid Status</th>
                  <th>If Lost/Reason</th>
                  <th>Client Feedback</th>
                  <th>RFQ Attachment File</th>
                </tr>
              </thead>
              <tbody>
                {currentData.length > 0 ? (
                  currentData.map((rfq, index) => (
                    <tr key={index}>
                      {user.deletestatus === "1" && (
                        <td className="sticky-col sticky-0 col-checkbox">
                          <input
                            type="checkbox"
                            checked={selectedRFQs.includes(rfq.id)}
                            onChange={() => handleSelectRFQ(rfq.id)}
                          />
                        </td>
                      )}
                      <td className="sticky-col sticky-1 col-action">
                        <button
                          className="btn btn-primary"
                          data-toggle="modal"
                          data-target="#statusModal"
                          onClick={() => openStatusModal(rfq)}
                        >
                          Edit
                        </button>
                        <Link
                          to={`/clonerfq/${rfq.id}`}
                          className="btn btn-secondary mx-2"
                        >
                          Clone
                        </Link>
                      </td>
                      <td className="sticky-col sticky-2 col-rfq">
                        {rfq.rfq_number || "-"}
                      </td>
                      <td className="sticky-col sticky-3 col-date">
                        {rfq.rfq_date || "-"}
                      </td>
                      <td>{limitWords(rfq.client_name)}</td>
                      <td>
                        <span
                          className={`btn btn-sm ${
                            statusStyles[rfq.status] || "btn-secondary"
                          }`}
                          disabled
                        >
                          {rfq.status || "-"}
                        </span>
                      </td>
                      <td>{rfq.closing_date || "-"}</td>
                      <td>{rfq.quote_submit_date || "-"}</td>
                      {/* <td>{limitWords(rfq.latest_update)}</td> */}
                      <td>
                        <TruncatedText text={rfq.latest_update} limit={40} />
                      </td>

                      <td>{limitWords(rfq.products)}</td>
                      <td>{limitWords(rfq.client_contact)}</td>

                      <td>{limitWords(rfq.client_email)}</td>

                      <td>
                        <TruncatedTextSupplier
                          text={rfq.manufacturer_supplier}
                          limit={15}
                        />
                      </td>

                      <td>{limitWords(rfq.assigned_staff)}</td>
                      <td>
                        <span
                          className={`btn btn-sm ${
                            bidStatusStyles[rfq.bid_status] || "btn-secondary"
                          }`}
                          disabled
                        >
                          {rfq.bid_status || "-"}
                        </span>
                      </td>
                      <td>{limitWords(rfq.if_lost)}</td>
                      <td>{limitWords(rfq.client_feedback)}</td>
                      <td>
                        {rfq.rfq_attachment ? (
                          <a
                            href={`${BASE_URL}/public/${rfq.rfq_attachment}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-sm btn-outline-primary mt-2"
                          >
                            View Current File
                          </a>
                        ) : (
                          "-"
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  /* ❌ NO DATA FOUND */
                  <tr>
                    <td
                      colSpan={user.deletestatus === "1" ? 22 : 21}
                      className=" text-muted py-4"
                      style={{ paddingLeft: "15px" }}
                    >
                      <strong>No data found</strong>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {totalPages > 1 && (
          <div className="mt-3 d-flex justify-content-center">
            <nav>
              <ul className="pagination">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => setCurrentPage(Math.max(currentPage - 1, 1))}
                  >
                    &laquo;
                  </button>
                </li>
                {getPaginationGroup().map((num) => (
                  <li
                    className={`page-item ${
                      num === currentPage ? "active" : ""
                    }`}
                    key={num}
                  >
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage(num)}
                    >
                      {num}
                    </button>
                  </li>
                ))}
                <li
                  className={`page-item ${
                    currentPage === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() =>
                      setCurrentPage(Math.min(currentPage + 1, totalPages))
                    }
                  >
                    &raquo;
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        )}

        {/* Status Modal */}
        <div
          className="modal fade"
          id="statusModal"
          tabIndex="-1"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Update RFQ</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div
                className="modal-body"
                style={{ height: 400, overflowY: "auto" }}
              >
                {selectedRFQ && (
                  <form>
                    <div className="row">
                      <div className="form-group mb-3 col-lg-6">
                        <label>
                          <strong>RFQ Attachment</strong>
                        </label>
                        <br />
                        <input
                          type="file"
                          onChange={(e) => setFile1(e.target.files[0])}
                        />
                        <input
                          type="hidden"
                          name="old_file"
                          value={selectedRFQ.rfq_attachment}
                        />
                        {selectedRFQ?.rfq_attachment && (
                          <a
                            href={`${BASE_URL}/public/${selectedRFQ.rfq_attachment}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-sm btn-outline-primary mt-2"
                          >
                            View Current File
                          </a>
                        )}
                      </div>

                      <div className="form-group mb-3 col-lg-6">
                        <label>
                          <strong>
                            Client Name <span className="textred">*</span>
                          </strong>
                        </label>
                        <Select
                          options={[
                            ...clients.map((c) => ({
                              label: c.client_name,
                              value: c.client_name,
                            })),
                            { label: "➕ Add New Client", value: "add_new" },
                          ]}
                          value={
                            selectedRFQ.client_name
                              ? {
                                  label: selectedRFQ.client_name,
                                  value: selectedRFQ.client_name,
                                }
                              : null
                          }
                          onChange={(selectedOption) => {
                            if (!selectedOption) return;
                            const value = selectedOption.value;
                            if (value === "add_new") {
                              window.location.href = "/clientadd";
                              return;
                            }
                            setSelectedRFQ((prev) => ({
                              ...prev,
                              client_name: value,
                            }));
                          }}
                          placeholder="Select Client"
                          isSearchable
                        />
                      </div>

                      {Object.entries({
                        manufacturer_supplier: "Manufacturer/Supplier",
                        rfq_number: "RFQ Number",
                        rfq_date: "RFQ Received Date",
                        client_contact: "Client Contact",
                        client_email: "Client Email",
                        closing_date: "RFQ Closing Date",
                        products: "Item Description",
                        quote_submit_date: "Quote Submit Date",
                        assigned_staff: "Assigned Staff",
                        latest_update: "Latest Update",
                        client_feedback: "Client Feedback",
                      }).map(([key, label]) => {
                        // Define required fields
                        const requiredFields = [
                          "rfq_number",
                          "rfq_date",
                          "quote_submit_date",
                          "closing_date",
                        ];
                        const isRequired = requiredFields.includes(key);

                        return (
                          <div key={key} className="form-group mb-3 col-lg-6">
                            <label>
                              {label}{" "}
                              {isRequired && <span className="textred">*</span>}
                            </label>

                            {key === "latest_update" ? (
                              <textarea
                                className="form-control"
                                name={key}
                                rows={3}
                                value={selectedRFQ[key] || ""}
                                onChange={handleInputChange}
                                required={isRequired}
                              ></textarea>
                            ) : (
                              <input
                                type={
                                  [
                                    "rfq_date",
                                    "closing_date",
                                    "quote_submit_date",
                                  ].includes(key)
                                    ? "date"
                                    : "text"
                                }
                                className="form-control"
                                name={key}
                                value={selectedRFQ[key] || ""}
                                onChange={handleInputChange}
                                required={isRequired}
                              />
                            )}
                          </div>
                        );
                      })}

                      <div className="form-group mb-3 col-lg-6">
                        <label>
                          <strong>If Lost</strong>
                        </label>
                        <select
                          name="if_lost"
                          className="form-control"
                          value={selectedRFQ.if_lost}
                          onChange={handleInputChange}
                        >
                          <option value="">Select</option>
                          <option>Price</option>
                          <option>Technical</option>
                          <option>Other</option>
                        </select>
                      </div>

                      <div className="form-group mb-3 col-lg-6">
                        <label>Status</label>
                        <select
                          name="status"
                          className="form-control"
                          value={selectedRFQ.status || ""}
                          onChange={handleInputChange}
                        >
                          <option value="">Select</option>
                          {Object.keys(statusStyles).map((s) => (
                            <option key={s} value={s}>
                              {s}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="form-group mb-3 col-lg-6">
                        <label>Bid Status</label>
                        <select
                          name="bid_status"
                          className="form-control"
                          value={selectedRFQ.bid_status || ""}
                          onChange={handleInputChange}
                        >
                          <option value="">Select</option>
                          {Object.keys(bidStatusStyles).map((b) => (
                            <option key={b} value={b}>
                              {b}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </form>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  data-dismiss="modal"
                  onClick={submitStatusUpdate}
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListRFQ;
